export enum COLORS {
  white = '#fff',
  black = '#000',
  mediumBlack = '#333333',
  chartConfigcolor = '#06698E',
  gridLineColor = '#579ab3',
  donutChartColor1 = '#E97F04',
  donutChartColor2 = '#3BB9AB',
  donutChartColor3 = '#0A8F32',
  lightGrey = '#b7b7b7',
  mediumGrey = '#9b9b9b',
  primaryBlue = '#0072BC',
  primaryLightOrange = '#FFA407',
  pictonBlue = '#2683d4',

  secondaryDarkBlue = '#06698E',
  secondaryLighOrange = '#F99D32',
  secondaryMediumOrange = '#F5842E',
  secondaryDarkOrange = '#E97F04',

  secondaryFaintGrey = '#B7B7B7',
  secondaryVeryFaintGrey = '#ECE8E8',
  secondaryWhitishGrey = '#F6F6F6'
}
